import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=d89ea852&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=d89ea852&prod&scoped=true&lang=css"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=d89ea852&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89ea852",
  null
  
)

export default component.exports